// extracted by mini-css-extract-plugin
export default {"link":"style_link__rmVO1","centerGrid":"style_centerGrid__TxcUU","img":"style_img__y6VnB","namegame":"style_namegame__b9RKa","center":"style_center__MauFe"};